import React, { memo } from 'react';
import { useTranslation } from 'i18n';

import NestedMultipleFilterSelect from 'components/common/NestedSelect/NestedMultipleFilterSelect';
import { useSelector } from 'react-redux';
import { DetectMarketSelectors, MarketsSelectors } from 'store/selectors';
import { RootState } from 'store/rootReducer';
import { titleLabelFormatter } from './utils';

export interface IFilterProps {
  disabled?: boolean;
}

const EventNeighborhoodsFilter: React.FC<React.PropsWithChildren<IFilterProps>> = (props) => {
  const { disabled } = props;

  const [t] = useTranslation();
  const market_slug = useSelector(DetectMarketSelectors.getSelectedMarket);
  const market = useSelector((state: RootState) => MarketsSelectors.marketBySlug(state, market_slug));

  return (
    <NestedMultipleFilterSelect
      labelFormatter={titleLabelFormatter}
      items={market?.neighborhoods || []}
      name="neighborhood"
      placeholderFormatter={(item: any) => item?.title || t('common:filter.neighborhoods')}
      disabled={disabled}
    />
  );
};

export default memo(EventNeighborhoodsFilter);
